<template>
  <section class="w-full flex flex-col md:flex-row md:justify-center lg:justify-between items-center text-lg gap-x-9 gap-y-6 pb-2 md:pb-4 lg:pb-0 lg:border-none  " :class="{'border-b border-black': bgActive,}">
    <section >
      <img :src="require(`../assets/${img}`)" class="w-12 h-12  object-contain rounded-2.5" :class="{'bg-gray-400': bgActive,}" />
    </section>
    <section>
      <p
        class="max-w-md md:max-w-138 lg:max-w-md"
        v-html="item"
        :class="textStyles"
      />

    </section>
  </section>
</template>
<script>
export default {
  props: {
    item:{
      default: null,
    },
    textStyles: {
      default: null,
    },
    img:{
      default: null,
    },
    bgActive:{
      default: true,
    }
  },
};
</script>